import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound(){

    return(
        <div style={{color:"white"}}>
           <div style={{ padding: '20px', textAlign: 'center' }}>
                <h1>404 - Page Not Found</h1>
                <p>Sorry, the page you are looking for does not exist.</p>
                <Link to="/private/main">Go Home</Link>
                </div>
        </div>
    )
}